import TextareaCentered from './textarea-centered'
export type { TextareaCenteredProps } from './textarea-centered'
export default TextareaCentered
